import React from "react";

const AdminDashboardPage: React.FC = () => {
  return (
    <div>
      <h1>Admin Dashboard</h1>
      <p>Welcome to the admin dashboard!</p>
      {/* Add more components and content here */}
    </div>
  );
};

export default AdminDashboardPage;
